import {useQuery} from "@tanstack/react-query";
import {getBillingPayment} from "../../api/api";
import handleUnauthorized401QueryError from "../../utils/handleUnauthorized401QueryError";
import {toast} from "react-toastify";
import {useContext, useState} from "react";
import AuthContext from "../../context/AuthContext";
import RecordsNotFound from "../../components/RecordsNotFound";
import Paginator from "../../components/Paginator";

const PAYMENT_TYPE_LABELS = {
    PREAUTH: 'Pre-authorization',
    RECURRING: 'Recurring charge',
};

const STATUS_BADGE = {
    CAPTURED: 'bg-success',
    REFUNDED: 'bg-info',
    FAILED: 'bg-danger',
    AUTHORIZED: 'bg-warning',
    CREATED: 'bg-secondary',
};

function BillingPaymentTab() {
    const {refreshToken} = useContext(AuthContext)
    const [page, setPage] = useState(1);

    const { status, data, error, isFetching, refetch } = useQuery({
        queryKey: ['billing-payment', page],
        queryFn: () => getBillingPayment(page),
        keepPreviousData: true,
        retry: false,
        onError: (err => {
            handleUnauthorized401QueryError(err, refreshToken, refetch)
            if (err.response.status !== 401) {
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        }),
    })

    return (
        <>
            {status === 'success' | error?.response?.status === 401 && (
                <div className="mt-3">
                    <div className="mb-3">
                        <h4 className="mb-1">Billing Payments</h4>
                        <p className="text-muted mb-0">
                            Payments collected by BlackX, including the ₹1 mandate authorization
                            (auto-refunded) and recurring usage charges.
                        </p>
                    </div>
                    <div className="table-responsive">
                        <table className="table table-centered mb-0">
                            <thead className="font-13 bg-light text-muted">
                            <tr>
                                <th>Date</th>
                                <th>Payment ID</th>
                                <th>Type</th>
                                <th>Method</th>
                                <th>Amount</th>
                                <th>Invoice</th>
                                <th>Status</th>
                            </tr>
                            </thead>
                            <tbody>
                            {data?.count > 0 ? data?.results?.map(pmt => (
                                <tr key={pmt.id}>
                                    <td>{new Date(pmt.created).toLocaleString()}</td>
                                    <th>{pmt.razorpay_payment_id}</th>
                                    <td>{PAYMENT_TYPE_LABELS[pmt.payment_type] || pmt.payment_type}</td>
                                    <td>{pmt.method || '-'}</td>
                                    <td>{pmt.currency} {pmt.amount}</td>
                                    <td>{pmt.invoice_number || '-'}</td>
                                    <td>
                                        <span className={`badge ${STATUS_BADGE[pmt.status] || 'bg-secondary'}`}>
                                            {pmt.status}
                                        </span>
                                        {pmt.status === 'FAILED' && pmt.error_description && (
                                            <div className="text-danger font-12 mt-1">{pmt.error_description}</div>
                                        )}
                                    </td>
                                </tr>
                            )) : <RecordsNotFound/>}
                            </tbody>
                        </table>
                        {status === 'success' && (
                            <Paginator data={data} page={page} setPage={setPage} last={data?.last_page} loading={isFetching}/>
                        )}
                    </div>
                </div>
            )}
        </>
    );
}

export default BillingPaymentTab;
